<app-alert-detalhe-fatura [alertDetalheFatura]="showAlertFatura" [dadosFatura]="dadosDetalheFatura"
(alertFaturaFechou)="fecharAlertFatura($event)"></app-alert-detalhe-fatura>
<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- BUSCAR PEDIDO PELO NÚMERO DO PEDIDO -->
        <div class="input-group float-end input-busca-pedidos">
          <input type="text" class="form-control sombra"
                 [disabled]="!('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)" [ngClass]="{
                      disabled: !('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)
                    }"
            [(ngModel)]="cnpjInput"
            mask="AA.AAA.AAA/AAAA-00"
            [dropSpecialCharacters]="true"
            placeholder="Buscar por CNPJ"
            id="inputCnpj">
          <button
            class="btn-icon p-0 border-0 bg-transparent"
            (click)="buscarPorCNPJ()"
            aria-label="Buscar por CNPJ">
            <i class="fa fa-search c-primary icone-lupa" id="iconeLupa" aria-hidden="true"></i>
          </button>
        </div>
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Demonstrativos de faturas</h1>
        <p class="paragrafo mb-4">Detalhamento de notas fiscais</p>

        <div class="row mb-3">
          <div class="col-12 pt-1 d-flex align-items-center">
            <button class="botao-filtro ativo me-3 mb-3" id="btnEmitidasUmMes"
                    [disabled]="!('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)" [ngClass]="{
                            disabled: !('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async),
                            ativo: tipoBusca == 'UM'
                         }" (click)="filtrarBotao('UM')">Emitidas há um mês
            </button>
            <button class="botao-filtro me-3 mb-3" id="btnUltimaEmissao"
                    [disabled]="!('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)" [ngClass]="{
                            disabled: !('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async),
                            ativo: tipoBusca == 'U1'
                         }" (click)="filtrarBotao('U1')">Última emissão
            </button>
            <button class="botao-filtro me-3 mb-3" id="btnEmitidasUmAno"
                    [disabled]="!('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)" [ngClass]="{
                            disabled: !('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async),
                            ativo: tipoBusca == 'UA'
                        }" (click)="filtrarBotao('UA')">Emitidas há um ano
            </button>
            @if (!filtrarData) {
              <button class="botao-filtro me-3 mb-3" id="btnPorData" (click)="filtrarBotao('data'); filtrarData = true"
                >Por data
              </button>
            }


            @if (filtrarData) {
              <div class="col-2 me-3 mb-2">
                <input class="form-control d-inline m-0" dateMask [matDatepicker]="picker1" id="dataInicial"
                  [(ngModel)]="dataInicial" [ngClass]="{ 'ativo': filtrarData }" placeholder="dd/mm/aaaa"
                  >
                <mat-datepicker-toggle matSuffix [for]="picker1" class="datepicker-custom-float"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </div>
            }

            @if (filtrarData) {
              <div class="col-2 me-3 mb-2">
                <input class="form-control d-inline m-0" dateMask [matDatepicker]="picker2" id="dataFinal"
                  [(ngModel)]="dataFinal" [ngClass]="{ 'ativo': filtrarData }" placeholder="dd/mm/aaaa"
                  >
                <mat-datepicker-toggle matSuffix [for]="picker2" class="datepicker-custom-float"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </div>
            }

            @if (filtrarData) {
              <button class="botao-outline mb-3" id="btnFiltrar" (click)="filtrarBotaoData()"
                    [disabled]="!('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)" [ngClass]="{
                            disabled: !('PedidosDemonstrativoDeFaturas' | usuarioPermissao:'Imprimir' | async)
                          }">FILTRAR
              </button>
            }
            @if (!filtrarData && cnpjFiltrado) {
              <button class="botao-outline mb-3" (click)="limparFiltro()">Limpar
                Filtro
              </button>
            }
          </div>
          <div class="col-12 pe-5 text-end">
            @if (filtrarData && dataFiltrada && !cnpjFiltrado) {
              <button
                class="btn p-0 border-0 bg-transparent limpar-filtro pe-3"
                (click)="limparFiltro()">
                Limpar Filtro
              </button>
            }
            @if (filtrarData && cnpjFiltrado) {
              <button
                class="btn p-0 border-0 bg-transparent limpar-filtro pe-3"
                (click)="limparFiltro()">
                Limpar Filtro
              </button>
            }
          </div>
        </div>

        <!-- FATURAS - 100% -->
        @if (faturas) {
          <div class="row">
            <mat-accordion multi="true">
              @for (fatura of faturas | paginate: { id: 'paginacaoFaturas',
                itemsPerPage: faturasPorPagina,
                currentPage: paginaFatura,
                totalItems: $safeNavigationMigration(faturas?.length) }; track fatura; let i = $index) {
                <div class="col-12">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <h3 class="info-empresas">{{fatura.cnpj | cnpj}}   {{fatura.razaoSocial}}</h3>
                    </mat-expansion-panel-header>
                    <div class="row linha">
                      <div class="coluna-seta"></div>
                      <div class="coluna-pedido">
                        <span class="label-menor mb-0">PEDIDO</span>
                      </div>
                      <div class="coluna-cnpj">
                        <span class="label-menor mb-0">CNPJ FATURADO</span>
                      </div>
                      <div class="coluna-emissao">
                        <span class="label-menor mb-0">EMISSÃO</span>
                      </div>
                      <div class="coluna-rps">
                        <span class="label-menor mb-0">RPS</span>
                      </div>
                      <div class="coluna-nf">
                        <span class="label-menor mb-0">
                          NF
                          <i
                            class="fa fa-info-circle c-gray fa-1x ms-2"
                            aria-hidden="true"
                            [popover]="popoverNf"
                            popoverTitle="Disponível para download"
                            popoverPlacement="top"
                            triggers="click"
                            [outsideClick]="true">
                          </i>
                        </span>
                        <ng-template #popoverNf>
                          <span class="paragrafo">
                            A nota fiscal ficará disponível para download em até 24h após a emissão da RPS.
                          </span>
                        </ng-template>
                      </div>
                      <div class="coluna-valor-nota">
                        <span class="label-menor mb-0">VALOR TOTAL<br>DA NOTA</span>
                      </div>
                      <div class="coluna-valor-fatura">
                        <span class="label-menor mb-0">VALOR TOTAL<br>DA FATURA</span>
                      </div>
                      <div class="coluna-vencimento">
                        <span class="label-menor mb-0">VENCIMENTO</span>
                      </div>
                    </div>
                    @for (detalhe of fatura.detalhes; track detalhe; let iFatura = $index) {
                      <div class="row linha">
                        <div class="coluna-seta">
                          @if (detalhe.flagImpressaoNF == 'S') {
                            <i class="icone fa fa-eye c-primary" aria-hidden="true"></i>
                          }
                          @if (detalhe.flagImpressaoNF == 'N') {
                            <i class="icone fa fa-eye-slash c-secondary"
                            aria-hidden="true"></i>
                          }
                        </div>
                        <div class="coluna-pedido">
                          <p class="descricao">{{detalhe.idPedido}}</p>
                        </div>
                        <div class="coluna-cnpj">
                          <p class="descricao">{{fatura.cnpj | cnpj}}</p>
                        </div>
                        <div class="coluna-emissao">
                          <p class="descricao">{{detalhe.dataEmissaoNF | appDate: 'dd/MM/yyyy'}}</p>
                        </div>
                        <div class="coluna-rps">
                          @if (detalhe.numeroRpsNF) {
                            <button
                              class="botao-rps"
                              (click)="detalharFatura(detalhe.numeroSerieNF, detalhe.idNotaFiscal)"
                              aria-label="Detalhar fatura">
                              <p>{{detalhe.numeroRpsNF}}
                                <i class="fa fa-download float-end mt-1" aria-hidden="true"></i>
                              </p>
                            </button>
                          }
                        </div>
                        <div class="coluna-nf">
                          @if (detalhe.urlNFE) {
                            <button
                              class="botao-nf"
                              (click)="marcarLeitura(i, iFatura)"
                              aria-label="Baixar nota fiscal">
                              <a href="{{detalhe.urlNFE}}" target="_blank">
                                <p>{{detalhe.idNotaFiscal}}
                                  <i class="fa fa-download float-end mt-1" aria-hidden="true"></i>
                                </p>
                              </a>
                            </button>
                          }
                        </div>
                        <div class="coluna-valor-nota">
                          <p class="descricao">{{detalhe.valorTotalNota}}</p>
                        </div>
                        <div class="coluna-valor-fatura">
                          <p class="descricao">{{detalhe.valorTotalFatura}}</p>
                        </div>
                        <div class="coluna-vencimento">
                          <p class="descricao">{{detalhe.dataVencimento | appDate: 'dd/MM/yyyy'}}</p>
                        </div>
                      </div>
                    }
                  </mat-expansion-panel>
                </div>
              }
            </mat-accordion>
          </div>
        }

        <!-- FOOTER-CARD - PAGINAÇÃO - EMPRESAS FILTRADAS -->
        @if (faturas) {
          <div class="footer-card">
            <div>
              <app-select
                [value]="faturasPorPagina"
                (valueChanges)="onFaturasPorPaginaChange($event)"
                name="faturasPorPaginaName"
              [options]="[
                        {name : 'Exibir 3 endereços' , value : '3'} ,
                        {name : 'Exibir 6 endereços' , value : '6'} ,
                        {name : 'Exibir 9 endereços' , value : '9'}

                        ]"
                optionValue="value"
                optionText="name">
              </app-select>
            </div>
            <!-- Paginação CENTRAL -->
            <div>
              <pagination-controls class="my-pagination" id="paginacaoFaturas" directionLink="true"
                (pageChange)="paginaFatura = $event" responsive="true" previousLabel="Anterior"
              nextLabel="Próxima"></pagination-controls>
            </div>
            <div>
              <p><span class="itens-pagina">{{totalFaturas}}</span> faturas foram encontradas</p>
            </div>
          </div>
        }

        <!-- CARREGAMENTO FATURAS -->
        @if (faturas === null) {
          <div>
            <div class="text-center">
              <output class="spinner-border c-primary">
                <span class="visually-hidden">Consultando faturas ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Consultando faturas ...</p>
          </div>
        }

        <!-- CASO DE ERRO FATUAS -->
        @if (faturas === false) {
          <div class="text-center">
            <img src="/assets/img/erro.png" width="230px" alt="Erro">
            <p class="legenda-erro">Ocorreu um erro na consulta das faturas.</p>
          </div>
        }

        <!-- CASO NÃO TENHA FATUAS RELACIONADAS -->
        <!-- EMPRESA NÃO POSSUI PEDIDOS -->
        @if (faturas === undefined) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" width="230px" alt="Erro">
            <p class="legenda-vazio">Nenhuma fatura encontrada.</p>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
